import React from 'react';
import styled from 'styled-components';
import { fontSmoothing } from '@finect/tabular-utils/fontSmoothing';
var Badge = styled.span.withConfig({
  displayName: "AdviserBadge__Badge",
  componentId: "sc-9pfo9z-0"
})(["display:inline-block;padding:2px 9px;border-radius:19px;background-color:", ";font-size:13px;", ";line-height:15px;color:#fff;"], function (_ref) {
  var theme = _ref.theme;
  return theme.badgeColor;
}, fontSmoothing);
export var AdviserBadge = function AdviserBadge(_ref2) {
  var title = _ref2.title;
  return React.createElement(Badge, null, title || 'Asesor');
};